const UserInfo = [
  {
    label: "حساب موثق",
    icon: "verified-account",
    key: "iam_verified",
    value: true,
  },
  { label: "مكتب نظامي", icon: "verified-office", key: "type", value: 1 },
  { label: "عميل مشترك", icon: "subscribed-1", key: "paid", value: 1 },
  { label: "عميل مشترك", icon: "subscribed-4", key: "paid", value: 4 },
  {
    label: "عقاري متميز",
    icon: "subscribed-2",
    key: "paid",
    value: 2,
  },
  { label: "عقاري محترف", icon: "subscribed-3", key: "paid", value: 3 },
  {
    label: "ملتزم بالرسوم",
    icon: "committed-to-fees",
    key: "fee",
    value: true,
  },
  { label: "خبير أراضي", icon: "land-expert", key: "le", value: true },
  { label: "خبير شقق", icon: "apartment-expert", key: "ae", value: true },
  { label: "إعلانات مصورة", icon: "picture-expert", key: "pe", value: true },
];

export default UserInfo;
